import apiReward from '@/api/vo/reward';

const defaultState = () => ({
	listRewardPremiumRO: [],
	rewardPremiumROPagination: '',
	listHistoryRewardPremiumRO: [],
	historyRewardPremiumROPagination: '',

	listRewardRO: [],
	rewardROPagination: '',
	listHistoryRewardRO: [],
	historyRewardROPagination: '',
	listHistoryRewardROPoint: [],
	
	listRewardTitik: [],
	rewardTitikPagination: '',
	listHistoryRewardTitik: [],
	historyRewardTitikPagination: '',

	listRewardPribadi: [],
	rewardPribadiPagination: '',
	listHistoryRewardPribadi: [],
	historyRewardPribadiPagination: '',

	listRewardGroup: [],
	rewardGroupPagination: '',
	listHistoryRewardGroup: [],
	historyRewardGroupPagination: '',
	listHistoryRewardPoint: [],

	pointRewardKhasanah: [],
	listRewardKhasanah: [],
	rewardKhasanahPagination: '',
	listHistoryRewardKhasanah: [],
	historyRewardKhasanahPagination: '',

	pointRewardEkonomi: [],
	listRewardEkonomi: [],
	rewardEkonomiPagination: '',
	listHistoryRewardEkonomi: [],
	historyRewardEkonomiPagination: '',

	responSukses: {},
	responseError: {},
	konfirmResponse: {},
});

const state = defaultState();

const getters = {

};

const mutations = {

	setRewardPremiumRO(state, data) {
		state.listRewardPremiumRO = data.data;
		state.rewardPremiumROPagination = data.pagination;
	},
	setHistoryRewardPremiumRO(state, data) {
		state.listHistoryRewardPremiumRO = data.data;
		state.historyRewardPremiumROPagination = data.pagination;
	},

	setRewardRO(state, data) {
		state.listRewardRO = data.data;
		state.rewardROPagination = data.pagination;
	},
	setHistoryRewardRO(state, data) {
		state.listHistoryRewardRO = data.data;
		state.historyRewardROPagination = data.pagination;
	},
	setHistoryRewardROPoint(state, data) {
		state.listHistoryRewardROPoint = data.data;
	},

	setRewardKhasanah(state, data) {
		state.listRewardKhasanah = data.data;
		state.rewardKhasanahPagination = data.pagination;
		state.pointRewardKhasanah = data.point
	},
	setHistoryRewardKhasanah(state, data) {
		state.listHistoryRewardKhasanah = data.data;
		state.historyRewardKhasanahPagination = data.pagination;
	},

	setRewardEkonomi(state, data) {
		state.listRewardEkonomi = data.data;
		state.rewardEkonomiPagination = data.pagination;
		state.pointRewardEkonomi = data.point
	},
	setHistoryRewardEkonomi(state, data) {
		state.listHistoryRewardEkonomi = data.data;
		state.historyRewardEkonomiPagination = data.pagination;
	},

	setSuksesClaim(state, data) {
		state.responSukses = data
	},
	
	setRewardTitik(state, data) {
		state.listRewardTitik = data.data;
		state.rewardTitikPagination = data.pagination;
	},
	setHistoryRewardTitik(state, data) {
		state.listHistoryRewardTitik = data.data;
		state.historyRewardTitikPagination = data.pagination;
	},

	setRewardPribadi(state, data) {
		state.listRewardPribadi = data.data;
		state.rewardPribadiPagination = data.pagination;
	},
	setHistoryRewardPribadi(state, data) {
		state.listHistoryRewardPribadi = data.data;
		state.historyRewardPribadiPagination = data.pagination;
	},

	setRewardGroup(state, data) {
		state.listRewardGroup = data.data;
		state.rewardGroupPagination = data.pagination;
	},
	setHistoryRewardGroup(state, data) {
		state.listHistoryRewardGroup = data.data;
		state.historyRewardGroupPagination = data.pagination;
	},
	setHistoryRewardPoint(state, data) {
		state.listHistoryRewardPoint = data.data;
	},

	saveResponseError(state, data) {
		state.responseError = data;
	},
	saveResponse(state, data) {
		state.responSukses = data
		state.responseError = ''
	},
};

const actions = {

	getRewardPremiumRO({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardPremiumRO(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardPremiumRO', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardPremiumRO', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardPremiumRO({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardPremiumRO(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardPremiumRO', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardPremiumRO', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getRewardRO({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardRO(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardRO', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardRO', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardRO({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardRO(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardRO', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardRO', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardROPoint({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardROPoint(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardROPoint', data.results)
					resolve(data.results)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardROPoint', []);
				reject()
			});
		});
	},

	getRewardKhasanah({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardKhasanah(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardKhasanah', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardKhasanah', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardKhasanah({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardKhasanah(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardKhasanah', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardKhasanah', { data: [], pagination: {} });
				reject()
			});
		});
	},

	claimRewardKhasanah({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.claimRewardKhasanah(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuksesClaim', data.results.data );
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, klaim reward tidak dapat diproses.'
				}, { root: true });
				commit('setSuksesClaim', { data: {} });
				reject()
			});
		});
	},

	getRewardEkonomi({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardEkonomi(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardEkonomi', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardEkonomi', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardEkonomi({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardEkonomi(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardEkonomi', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardEkonomi', { data: [], pagination: {} });
				reject()
			});
		});
	},

	claimRewardEkonomi({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.claimRewardEkonomi(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuksesClaim', data.results.data );
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, klaim reward tidak dapat diproses.'
				}, { root: true });
				commit('setSuksesClaim', { data: {} });
				reject()
			});
		});
	},

	getRewardTitik({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardTitik(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardTitik', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardTitik', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardTitik({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardTitik(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardTitik', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardTitik', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getRewardPribadi({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardPribadi(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardPribadi', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardPribadi', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardPribadi({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardPribadi(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardPribadi', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardPribadi', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getRewardGroup({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getRewardGroup(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setRewardGroup', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setRewardGroup', { data: [], pagination: {} });
				reject()
			});
		});
	},

	getHistoryRewardGroup({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardGroup(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardGroup', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardGroup', { data: [], pagination: {} });
				reject()
			});
		});
	},
	
	getHistoryRewardPoint({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiReward.getHistoryRewardPoint(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setHistoryRewardPoint', data.results)
					resolve(data.results)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setHistoryRewardPoint', []);
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};